<ng-container *transloco="let t;">
  <div class="card-header pb-50">
    <div class="d-flex align-items-center">
      <h4 class="card-title font-medium-1">{{ t('Latest activity (Dashboard latest activity widget title) - Latest
        activity') }}</h4>
    </div>
  </div>
  <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="lastestActivityWidgetScroll">
    <div class="card-body">
      <ul class="timeline">
        @for(activity of (latestAcitivites$ | async)?.data; track activity){
        <li class="timeline-item">
          <span class="timeline-point timeline-point-indicator"
            [ngClass]="activity.status | documentStatusHelper:'timeline-point'"></span>
          <div class="timeline-event">
            <div class="d-flex justify-content-between flex-sm-row columngap mb-sm-0 mb-1">
              <div>
                @if(activity?.status === 'draft'){
                <div class="">
                  <ng-container
                    *ngTemplateOutlet="sender; context: {activity:activity,time:activity.updated_at,status:'draft'}"></ng-container>
                </div>
                }
                @else if(activity?.status === 'uploaded'){
                <div class="">
                  <ng-container
                    *ngTemplateOutlet="sender; context: {activity:activity,time:activity.updated_at,status:'uploaded'}"></ng-container>
                </div>
                }@else{
                @for (participant of activity?.recipient_roles; track participant; let i = $index) {
                @if (participant.recipient_role_detail) {
                <ng-container *ngIf="participant.recipient_role_detail.is_sender === 1; else nonSender">
                  <div class="d-flex font-small-3 align-items-center justify-content-start">
                    <ng-container
                      *ngTemplateOutlet="sender; context: {activity:activity,time:participant.recipient_role_detail.status_updated_at,status:'sent'}"></ng-container>
                  </div>
                </ng-container>
                <ng-template #nonSender>
                  <span class="font-small-3 mb-25 activity-log-span d-flex">
                    <ng-container *ngIf="participant.recipient_role_detail.status as status">
                      <span *ngIf="[documentStatusesEnum.Sent, documentStatusesEnum.Delivered].includes(status)">
                        {{ t("Latest activity log for sender (Latest activity widget dashboard) - status to name", { status: (status | titlecase) }) }}
                      </span>
                      <span *ngIf="![documentStatusesEnum.Sent, documentStatusesEnum.Delivered, documentStatusesEnum.Waiting].includes(status)">
                        {{ t("Latest activity log for sender (Latest activity widget dashboard) - status by name", { status: (status | titlecase) }) }}
                      </span>              
                      <span *ngIf="status === documentStatusesEnum.Waiting">
                        {{t("Document waiting status (Latest Activity) - Waiting in order")}}
                      </span>
                    </ng-container>
                    <span class="font-small-3 fw-bold text-dark mx-25 mb-0">{{ participant.person | getRecipient }} </span>
                      <span *ngIf="participant?.recipient_role_detail?.status !== documentStatusesEnum.Waiting">
                        {{participant.recipient_role_detail.status_updated_at | dateConversationPipe | async}}
                      </span>
                    </span>
                </ng-template>
                }
                }
                }
              </div>
              <app-document-status-badge [documentStatus]="activity?.status"></app-document-status-badge>
            </div>
          </div>
        </li>
        } @empty {
        <div class="mb-1 p-4 mt-1 text-center cc-no-recordsDiv">
          <p class="text-muted mb-0">{{ t('No records (general) - No records') }}</p>
        </div>
        }
      </ul>
    </div>
  </ng-scrollbar>
  <ng-template #sender let-activity="activity" let-time="time" let-status="status">
    <div class="mb-25">
      <h6 class="mb-0 activity-Links-h6 d-inline"><a class="activity-Links" [routerLink]="['/documents']"
          [state]="{query:activity.document_number, document_id:activity.id}">{{activity?.name}}</a> </h6>
      <p class="mb-0 d-inline">
        {{ t("Latest activity log for sender (Latest activity widget dashboard) - status by name", { status: (status | titlecase) })
        }}
      </p>
      <p class="font-small-3 fw-bold d-inline text-dark mb-0">{{ activity?.user?.name }}</p>
      <p class="mb-0 d-inline">
        {{ time | dateConversationPipe | async }}
      </p>
    </div>
  </ng-template>
</ng-container>